/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable indent */
import React, { Component } from "react"
import PropTypes from "prop-types"
import Moment from "moment"

// D3
import { scaleBand, scaleLinear, scaleOrdinal } from "d3-scale"
import { stack, stackOffsetExpand } from "d3-shape"

// Components
import Axis from "../Axis/Axis"

// Utils
import { colors } from "../utils"

class StackedBarChart extends Component {
  render() {
    // Props
    const {
      keys,
      paddingInner,
      data,
      containerWidth,
      uniqueId,
      svgHeight,
      margin,
      isCurrentMonth
    } = this.props
    const svgWidth = containerWidth

    // Data
    const orderedData = []
    Object.keys(data).map(key => {
      const monthObj = data[key][Object.keys(data[key])]
      if (monthObj && monthObj.distribution) {
        orderedData.push(monthObj.distribution)
      }
      return orderedData
    })

    const labels = Object.keys(data).map(key => {
      return Moment(Object.keys(data[key])[0], "YYYYMM").format("MMM")
    })

    // Dimensions
    const w = svgWidth - margin.left - margin.right
    const h = svgHeight - margin.top - margin.bottom

    // Year label logic
    const monthsArray = []

    const yearLabels = Object.keys(data).map(key => {
      return Moment(Object.keys(data[key])[0], "YYYYMM").format("YYYY")
    })

    const yearList = yearLabels.filter((item, i, ar) => {
      return ar.indexOf(item) === i
    })

    const singleLabel = [yearList[0]] || []

    // Adjust labels range according to the number of months
    let range = w / (labels.length * 1.7)

    // If current month is January or if there is only one month of data, take whole width as range
    if (
      (isCurrentMonth && labels.length === 1 && labels[0] === "Jan") ||
      labels.length === 1
    ) {
      range = w
    }

    // X Scale
    const x = scaleBand()
      .domain(labels)
      .range([0, w])
      .paddingInner(paddingInner)

    // Year label scale
    const yearScale = scaleBand()
      .domain(singleLabel)
      .range([0, range])
      .paddingInner(paddingInner)

    // Y Scale
    const y = scaleLinear().range([h, 0])
    // Color Scale
    const z = scaleOrdinal()
      .domain(keys)
      .range(colors)

    // Data
    const barStack = stack()
      .keys(keys)
      .offset(stackOffsetExpand)
    const series = barStack(orderedData)

    const calculateYearLine = months =>
      (months["Dec"]["x"] + x.bandwidth() + months["Jan"]["x"] + 6) / 2

    return data.length ? (
      <svg width={svgWidth} height={svgHeight} className="stacked-bar-chart">
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          {series.map((level, i) => (
            // band segments
            <g
              key={`${uniqueId}-${level}-${i}`}
              fill={z(level.key)}
              className="bar"
            >
              {level.map((bar, i) => (
                <rect
                  key={`${uniqueId}-${labels[i]}-${bar}`}
                  x={x(labels[i])}
                  y={y(bar[1])}
                  height={y(bar[0]) - y(bar[1])}
                  width={x.bandwidth()}
                  clipPath={`url(#${uniqueId}-${i})`}
                />
              ))}
            </g>
          ))}
          {labels.map((label, i) => {
            monthsArray[label] = { x: x(label) }
            return (
              // bars
              <clipPath key={`${uniqueId}-${i}`} id={`${uniqueId}-${i}`}>
                <rect
                  x={x(label)}
                  y={0}
                  width={x.bandwidth()}
                  height={h}
                  rx="3"
                  ry="3"
                />
              </clipPath>
            )
          })}

          {/* Month Legend */}
          <Axis
            adjustTextLength
            textClass={
              isCurrentMonth
                ? "stacked-text highlight-legend-text"
                : "stacked-text"
            }
            orientation="bottom"
            classes="bar-x-axis"
            translate={`translate(0, ${h})`}
            scale={x}
          />
          {/* Year Legend */}
          {!(isCurrentMonth && labels[0] !== "Jan") && (
            <Axis
              adjustTextLength
              textClass={
                isCurrentMonth
                  ? "stacked-text highlight-legend-text"
                  : "year-legend"
              }
              orientation="bottom"
              classes="bar-x-axis"
              translate={`translate(0, ${h + 15})`}
              scale={yearScale}
            />
          )}
        </g>

        {/* Year divider line */}
        {!isCurrentMonth &&
          yearList.length > 1 &&
          monthsArray["Dec"] &&
          monthsArray["Jan"] && (
            <line
              x1={calculateYearLine(monthsArray)}
              y1={h}
              x2={calculateYearLine(monthsArray)}
              y2="0"
              stroke="#EEF0F3"
              strokeWidth="1"
            />
          )}

        {/* Second year legend */}
        {!isCurrentMonth && yearList.length > 1 && (
          <text
            x={monthsArray["Jan"]["x"] * 1.007}
            y="172"
            className="year-legend"
          >
            {yearList[1]}
          </text>
        )}
      </svg>
    ) : null
  }
}

export default StackedBarChart

StackedBarChart.propTypes = {
  containerWidth: PropTypes.number,
  keys: PropTypes.arrayOf(PropTypes.string),
  paddingInner: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      level_5: PropTypes.number,
      level_4: PropTypes.number,
      level_3: PropTypes.number,
      level_2: PropTypes.number,
      level_1: PropTypes.number
    })
  ),
  uniqueId: PropTypes.string.isRequired,
  svgHeight: PropTypes.number,
  margin: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  }),
  isCurrentMonth: PropTypes.bool
}

StackedBarChart.defaultProps = {
  containerWidth: 400,
  keys: ["level_5", "level_4", "level_3", "level_2", "level_1"],
  paddingInner: 0.5,
  data: [{ level_5: 0, level_4: 0, level_3: 0, level_2: 0, level_1: 0 }],
  svgHeight: 175,
  margin: {
    top: 0,
    bottom: 35,
    left: 3,
    right: 3
  },
  isCurrentMonth: false
}
